/* eslint-disable react/jsx-filename-extension, import/prefer-default-export */

import 'intersection-observer';
import wrapRootProvider from './src/utils/wrapRootProvider';

export const wrapRootElement = wrapRootProvider;
